import moment from 'moment';

import { MICE_CONSTANTS } from 'AppConstants';
import { logOmniClick } from 'omnitures';
import { dropQueryObj, defaultOptionSelected } from '../pages/mice/config';
import { eventTypeOptions, destinationTypeOptions } from '../pages/mice/filterConfig';

export const getTravelMonths = (labelFormat = {}, valueFormat = MICE_CONSTANTS.MONTH_FORMAT) => {
	let { mobileLabel = MICE_CONSTANTS.MONTH_FORMAT, desktopLabel = MICE_CONSTANTS.MONTH_FORMAT } = labelFormat;

	const travelMonths = [];
	const currentMonthLabel = moment().format(desktopLabel);
	const currentMonthLabelMobile = moment().format(mobileLabel);
	const currentMonthValue = moment().format(valueFormat);
	const selectFomat = {
		value: currentMonthValue,
		label: {
			labelHead: currentMonthLabel,
			labelHeadMobile: currentMonthLabelMobile
		}
	};
	travelMonths.push(selectFomat);

	for (let i = 1; i <= 11; i++) {
		const nextMonthLabel = moment().add(i, 'month').format(desktopLabel);
		const nextMonthLabelMobile = moment().add(i, 'month').format(mobileLabel);
		const nextMonthvalue = moment().add(i, 'month').format(valueFormat);
		const selectFomat = {
			value: nextMonthvalue,
			label: {
				labelHead: nextMonthLabel,
				labelHeadMobile: nextMonthLabelMobile
			}
		};
		travelMonths.push(selectFomat);
	}
	return travelMonths;
};

export const formatQueryForm = (fields = []) => {
	const retData = {};
	fields.forEach((field) => {
		let value = field.type === 'select' ? field.value.value : field.value;
		if (field.formatSave) {
			value = field.formatSave(value);
		}
		retData[field.name] = value;
	});
	return retData;
};

/**
 * formats Mice form data for post request
 * @author mybizFe
 * @param {Array} fields
 * @return {Object} formatted mice form data
 */
export const formatMiceForm = (fields = []) => {
	const retData = {};
	let shouldAddComment = true;
	for (let i = 0; i < fields.length; i++) {
		const { name, value: fieldValue, options, formatSave } = fields[i];
		let services = [];
		if (name === 'subHeading') {
			continue;
		}
		if (name === 'services') {
			options.forEach((item) => {
				if (item?.value) {
					services.push(item?.label);
				}
			});
		};
		let value = fieldValue;
		if (formatSave) {
			value = formatSave(value);
		}

		switch (name) {
			case 'services':
				retData[name] = services;
				break;
			case 'travelMonth':
				retData[name] = fields[i]?.value?.value;
				break;
			case 'guestCount':
				retData[name] = fields[i]?.value?.apiDataKey;
				break;
			case 'comments':
				if (shouldAddComment) {
					retData[name] = value;
				}
				break;
			default:
				retData[name] = value;
		}
	};
	return retData;
};

export const hotelFilterData = (selectedHotelData, searchFilterData) => {
	const { name, area } = selectedHotelData;
	const { destinationType, eventType, city } = searchFilterData;

	let reqObj = { destinationType, eventType };

	reqObj.destinationName = name;
	reqObj.destinationArea = area;
	reqObj.destinationCity = city;
	return reqObj;
};

export const trackMiceClick = (prop) => {
	const pageName = 'MICE_page:MICE_funnel|corporate';
	logOmniClick(MICE_CONSTANTS.MICE_CLICKEVT, {
		prop54: prop,
		pageName
	});
};

export const filterHotelSearch = (data) => {
	const { hotels = [], cities = [], defaultTermsAndConditions = [] } = data;
	const spliceLength = hotels.length > MICE_CONSTANTS.DEFAULT_CITY_LENGTH ?
		MICE_CONSTANTS.DEFAULT_CITY_LENGTH : hotels.length;
	const filterData = hotels.slice(0, spliceLength);
	filterData.push(dropQueryObj);
	// const cityData = cities.map(city => ({ label: city, value: city }))
	const cityData = [{ label: MICE_CONSTANTS.TOP_DESTINATION_CITY, value: '' }, ...cities.map((city) => ({ label: city, value: city }))];

	return {
		hotels: filterData,
		cities: cityData,
		defaultTermsAndConditions: defaultTermsAndConditions
	};
};

export const formatTravelMonth = (travelMonths) => travelMonths.map((month) => {
	const { value, label } = month;
	return {
		value,
		label: label.labelHead,
		mobileLabel: label.labelHeadMobile
	};
});

/**
 * formats search data for omniture tracking
 * @author mybizFe
 * @param {Object} searchData
 * @return {String} formatted omniture tracking string
 */
export const formatTrackingMiceValue = (searchData = {}) => {
	let propVal = '';

	for (let key in searchData) {
		if (key === 'eventType') {
			propVal += searchData[key] + '_explore_clicked';
			return propVal;
		}
		propVal += searchData[key] + '| ';
	}
};

/**
 * checks for error in form fields
 * @author mybizFe
 * @param {Array} formFields
 * @return {Boolean} whether there is error in form fields
 */
export const checkForError = (formFields = []) => {
	let error = false;
	const fieldLen = formFields.length;
	for (let i = 0; i < fieldLen; i++) {
		if (formFields[i].name === 'notesCheck') {
			continue;
		}
		let value = formFields[i]?.options?.every((item) => item.value === false);
		error = !formFields[i].value && formFields[i].isMandatory || formFields[i].error || value;
		if (error) {
			break;
		}
	}
	return error;
};

/**
 * checks for error in form fields
 * @author mybizFe
 * @param {Object} routeParams
 * @return {Boolean} whether there is error in form fields
 */
export const getMiceApiParams = (routeParams = {}) => {
	const { city, destinationType, eventType } = routeParams;
	const cityVal = (!city || city === defaultOptionSelected.city.urlDataKey) ? defaultOptionSelected?.city.value : city;
	const requestObj = {
		filter: {
			destinationType: defaultOptionSelected?.destinationType.value,
			eventType: defaultOptionSelected?.eventType.value,
			city: cityVal
		}
	};
	if (destinationType) {
		requestObj.filter.destinationType = destinationTypeOptions.filter((opt) => opt.urlDataKey === destinationType)[0]?.value || defaultOptionSelected?.destinationType.value;
	}
	if (eventType) {
		requestObj.filter.eventType = eventTypeOptions.filter((opt) => opt.urlDataKey === eventType)[0]?.value;
	}
	return requestObj;
};
